import ringTone1 from "../assets/audio/ringTone1.mp3"
import ringTone2 from "../assets/audio/ringTone2.mp3"
import ringTone3 from "../assets/audio/ringTone3.wav"
import ringTone4 from "../assets/audio/ringTone4.wav"
import ringbackToneAudio from "../assets/audio/ringbackTone.mp3"
import dtmfToneAudio from "../assets/audio/dtmfTone.mp3"

export const RINGTONES = {
    'ringTone1': {
        id: 'ringTone1',
        src: ringTone1,
        label: 'Default (Classic Bell)'
    },
    'ringTone2': {
        id: 'ringTone2',
        src: ringTone2,
        label: 'Digital Chime'
    },
    'ringTone3': {
        id: 'ringTone3',
        src: ringTone3,
        label: 'Gentle Marimba'
    },
    'ringTone4': {
        id: 'ringTone4',
        src: ringTone4,
        label: 'Crystal Tone'
    }
};

const audioElements = {
    local: document.createElement('audio'),
    remote: document.createElement('audio'),
    ringTone: document.createElement('audio'),
    ringbackTone: document.createElement('audio'),
    dtmfTone: document.createElement('audio'),
    previewTone: document.createElement('audio')
};

//setup audio elements
audioElements.local.muted = true;
audioElements.ringTone.src = RINGTONES.ringTone1.src;
audioElements.ringbackTone.src = ringbackToneAudio;
audioElements.dtmfTone.src = dtmfToneAudio;

export const setRingtone = (ringtoneId) => {
    const ringtone = RINGTONES[ringtoneId];
    if (ringtone) {
        audioElements.ringTone.src = ringtone.src;
        return true;
    }
    return false;
};

export const getAudio = (type) => audioElements[type];

//Play DTMF Tone
export const playDTMFTone = () => {
    audioElements.dtmfTone.currentTime = 0;
    audioElements.dtmfTone.play().catch(e => console.error("Error playing DTMF tone:", e));
};

// Play ringtone
export const playRingTone = () => {
    audioElements.ringTone.loop = true;
    audioElements.ringTone.play().catch(e => console.error("Error playing ringtone:", e));
};

// Stop ringtone
export const stopRingTone = () => {
    audioElements.ringTone.pause();
    audioElements.ringTone.currentTime = 0;
    audioElements.ringTone.load();
};

// Play ringback tone
export const playRingbackTone = () => {
    audioElements.ringbackTone.loop = true;
    audioElements.ringbackTone.play().catch(e => console.error("Error playing ringback tone:", e));
};

// Stop ringback tone
export const stopRingbackTone = () => {
    audioElements.ringbackTone.pause();
    audioElements.ringbackTone.currentTime = 0;
    audioElements.ringbackTone.load();
};

export const playPreviewTone = (ringtoneId) => {
    const ringtone = RINGTONES[ringtoneId];
    if (ringtone) {
        audioElements.previewTone.src = ringtone.src;
        audioElements.previewTone.currentTime = 0;
        audioElements.previewTone.play().catch(e => console.error("Error playing preview tone:", e));
    }
};

// Add new function to stop preview tone
export const stopPreviewTone = () => {
    audioElements.previewTone.pause();
    audioElements.previewTone.currentTime = 0;
    audioElements.previewTone.load();
};

export const changeSpeakerVolume = (volume) => {
    try {
        audioElements.remote.volume = volume;
        return true;
    } catch (error) {
        console.error('Error setting speaker volume:', error);
        return false;
    }
};

export const changeNotificationVolume = (volume) => {
    try {
        // Set volume for all audio elements except remote and local (which is muted)
        const elements = ['ringTone', 'ringbackTone', 'dtmfTone', 'previewTone'];
        elements.forEach(type => {
            const element = audioElements[type];
            element.volume = volume;
        });
        return true;
    } catch (error) {
        console.error('Error setting volume:', error);
        return false;
    }
};

export const setAudioOutputDevice = async (deviceId) => {
    console.log('[VERBOSE] These are the device we getting', deviceId)
    try {
        // Check if deviceId is valid
        if (!deviceId) {
            console.warn('Invalid deviceId provided');
            return false;
        }

        // Set the sink ID for all audio elements except local (which is muted)
        const elements = ['remote', 'ringTone', 'ringbackTone', 'dtmfTone', 'previewTone'];
        await Promise.all(
            elements.map(async (type) => {
                const element = audioElements[type];

                // Check and clean up remote stream if needed
                if (type === 'remote' && element.srcObject) {
                    const tracks = element.srcObject.getTracks();
                    const hasActiveTracks = tracks.some(track => track.readyState === 'live');

                    if (!hasActiveTracks) {
                        // Clean up old stream if no active tracks
                        element.srcObject = null;
                    }
                }

                if (element.setSinkId) {
                    await element.setSinkId(deviceId);
                }
            })
        );
        console.log('Audio output device set successfully');
        return true;
    } catch (error) {
        console.error('Error setting audio output device:', error);
        throw error;
    }
};